import styled from "styled-components";
import { textTheme, colorTheme } from "../../theme";

export const Container = styled.div`
  ${textTheme.h6};
  padding: 5px;
`;
export const Header = styled.div`
  ${textTheme.h6};
  margin-bottom: 20px;
`;

export const Body = styled.div`
  ${textTheme.body1};
  margin-bottom: 20px;
  color: ${colorTheme.grayDark};
`;

export const ButtonContainer = styled.div`
  margin-bottom: 10px;
`;

export const Button = styled.button<{ primary?: boolean }>`
  height: 42px;
  border: 1px solid ${colorTheme.newBlue};
  background-color: ${props =>
    props.primary ? colorTheme.newBlue : colorTheme.white};
  color: ${props => (props.primary ? colorTheme.white : colorTheme.newBlue)};
  box-sizing: border-box;
  border-radius: 4px;
  margin-right: 20px;
  padding-right: 15px;
  padding-left: 15px;
  ${textTheme.button}

  &:hover {
    cursor: pointer;
  }
`;
